// Note that the collection is extended from an array.
// However be careful when iterating through the properties as we may have added additional properties which will also be iterated over.

import OnlineAppCollection from "./online_app_collection";

export default class ExperienceCollection extends OnlineAppCollection {

    constructor(onlineApp=null,...items) {
        super(onlineApp, ...items);
    }

    withId(id) {
        if (this.isEmpty()) { return null }
        let matchingItems = this.filter( item => item.id == id );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

    withSlug(slug) {
        if (this.isEmpty()) { return null }
        let matchingItems = this.filter( item => item.slug == slug );
        let matchingItem = matchingItems[0];
        if (matchingItem) { return matchingItem } else { return null }
    }

    allWithRegionCode(regionCode) {
        if (this.isEmpty()) { return [] };
        return this.filter( item => item.regionCode == regionCode );
    }

    allWithExperienceIds(ids) {
        if (this.isEmpty()) { return [] };
        return this.filter( (item) => ids.includes(item.id) );
    }

}